import toast from 'react-hot-toast';
import { CheckCircle, XCircle, AlertCircle, Info, Sparkles } from 'lucide-react';

/**
 * Enhanced Toast Notifications
 * Better styled toast notifications with icons
 */

export const showSuccessToast = (message, duration = 3000) => {
  return toast.success(message, {
    duration,
    icon: '✅',
    style: {
      background: '#10b981',
      color: '#fff',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(16, 185, 129, 0.3)',
      fontSize: '15px',
      fontWeight: '500'
    },
    iconTheme: {
      primary: '#fff',
      secondary: '#10b981'
    }
  });
};

export const showErrorToast = (message, duration = 4000) => {
  return toast.error(message, {
    duration,
    icon: '❌',
    style: {
      background: '#ef4444',
      color: '#fff',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(239, 68, 68, 0.3)',
      fontSize: '15px',
      fontWeight: '500'
    },
    iconTheme: {
      primary: '#fff',
      secondary: '#ef4444'
    }
  });
};

export const showWarningToast = (message, duration = 3500) => {
  return toast(message, {
    duration,
    icon: '⚠️',
    style: {
      background: '#f59e0b',
      color: '#fff',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(245, 158, 11, 0.3)',
      fontSize: '15px',
      fontWeight: '500'
    },
    iconTheme: {
      primary: '#fff',
      secondary: '#f59e0b'
    }
  });
};

export const showInfoToast = (message, duration = 3000) => {
  return toast(message, {
    duration,
    icon: 'ℹ️',
    style: {
      background: '#3b82f6',
      color: '#fff',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(59, 130, 246, 0.3)',
      fontSize: '15px',
      fontWeight: '500'
    },
    iconTheme: {
      primary: '#fff',
      secondary: '#3b82f6'
    }
  });
};

export const showCelebrationToast = (message, duration = 4000) => {
  return toast.success(message, {
    duration,
    icon: '🎉',
    style: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(102, 126, 234, 0.4)',
      fontSize: '15px',
      fontWeight: '600'
    },
    iconTheme: {
      primary: '#fff',
      secondary: '#764ba2'
    }
  });
};

